/**
 * Used on FXD only
 */
document.addEventListener("DOMContentLoaded", function() {
    var elements = document.querySelectorAll('.product__title');
    replaceDiamonds(elements);
    waitForElm('.card-information__text').then(() => {
        var elements = document.querySelectorAll('.card-information__text');
        console.log(elements);
        replaceDiamonds(elements);
    });


    function replaceDiamonds(elements) {
        elements.forEach(function(element) {
            var html = element.innerHTML;
          
            if (html.indexOf('◆') > -1) {
              element.innerHTML = html.replace('◆', '<span class="diamond">◆</span>');
            }
        });
    }

    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
    
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
    
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }
});
